module.exports = __webpack_public_path__ + "img/SLN_thumb_320_212.a17bb9b3.jpg";